import { Kefir as K } from "kefir";

import offsetTop from "./offsetTop";

function propertyBy(resample, fn) {
  return resample.map(fn).toProperty(fn);
}

function elementBounds(resample, element) {
  const computedStyle = propertyBy(resample, () => getComputedStyle(element));

  const marginTop = computedStyle
    .map(style => parseInt(style.marginTop))
    .toProperty();

  const marginBottom = computedStyle
    .map(style => parseInt(style.marginBottom))
    .toProperty();

  const height = propertyBy(resample, () => element.offsetHeight);
  const width = propertyBy(resample, () => element.offsetWidth);
  const top = propertyBy(resample, () => offsetTop(element));
  const bottom = K.combine([top, height], (t, h) => t + h);

  const marginHeight = K.combine(
    [marginTop, marginBottom, height],
    (t, b, h) => t + b + h
  );

  return { height, top, bottom, marginTop, marginBottom, marginHeight };
}

export default elementBounds;



// WEBPACK FOOTER //
// ./app/javascript/packs/modules/elementBounds.js